<script lang="ts">
  import Player from '../../Players/Component.svelte'
  import { players, remove_player, assign_leader } from '../../Players/observables'
  import { DateTime } from 'luxon'
  import AuthedUserTopBarPage from '../../Navigation/TopLevelPages/AuthedUserTopBarPage.svelte'
  import CtaButton from '../../Generic/CtaButton.svelte'
  const alertOnError = (mayFail: () => Promise<void>): (() => Promise<void>) => {
    return async () => {
      try {
        await mayFail()
      } catch (err: unknown) {
        if (err instanceof Error) {
          alert(err.message)
        }
      }
    }
  }
</script>

<AuthedUserTopBarPage>
  <div id="players-list">
    {#if !$players}
      <p>No Friends yet</p>
    {:else}
      {#each $players || [] as player (player.uid)}
        <div class="player-row">
          <Player {...player} />
          <div class="player-details">
            <h3>{player.name}</h3>
            <small>
              Last Seen: {player.lastSeen.toLocaleString(DateTime.DATETIME_MED)}
            </small>
          </div>
          <div class="action-button">
            <CtaButton
              kind="negative"
              on:click={alertOnError(async () => void (await $remove_player(player.uid)))}
              >Remove Attendee</CtaButton
            >
          </div>
          <div class="action-button">
            <CtaButton on:click={alertOnError(async () => void (await $assign_leader(player.uid)))}
              >Assign Leader</CtaButton
            >
          </div>
        </div>
      {/each}
    {/if}
  </div>
</AuthedUserTopBarPage>

<style>
  .player-row {
    margin: auto;
    margin-top: 1em;
    padding: 1em;
    display: flex;
    flex-flow: row nowrap;
    width: 100vw;
    max-width: 700px;
    justify-content: space-around;
    border: 2px;
    border-radius: 2em;
    border-color: var(--primary);
    border-style: solid;
  }

  .action-button {
    align-self: center;
  }

  small {
    color: grey;
  }
</style>
